export enum ComponentId {
  TYPE = "type",
  NAME = "name",
  SURNAME = "surname",
  COMPANY_NAME = "companyName",
  PHONE = "phone",
  EMAIL = "email",
}
